import { Controller } from "stimulus";
import moment from "moment";
import daterangePickerPtBr from '../../entrypoints/src/admin/i18n/daterange-picker.pt-br';

export default class extends Controller {
  connect() {
    let _this = this;

    $(this.element.dataset.dateRangePicker).each((_, el) => {
      let picker = $(el),
        startDate = moment(picker.data('startDate')),
        endDate = moment(picker.data('endDate'));

      picker.daterangepicker({
        locale: daterangePickerPtBr,
        startDate: startDate,
        endDate: endDate,
        opens: 'left',
        applyButtonClasses: 'btn btn-sm btn-secondary',
        ranges: {
          'Penúltimo Mês': [moment().subtract(2, 'month').startOf('month'), moment().subtract(2, 'month').endOf('month')],
          'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          'Mês Atual': [moment().startOf('month'), moment().endOf('month')],
        }
      }, (start, end) => {
        _this.element.querySelector('input[name="start_date"]').value = start.format('DD/MM/YYYY');
        _this.element.querySelector('input[name="end_date"]').value = end.format('DD/MM/YYYY');
        _this.element.insertAdjacentHTML('beforeend', '<button class="hidden" id="formSubmissionTrigger">submit</button>');
        setTimeout(() => _this.element.querySelector('#formSubmissionTrigger').click());
      });

      this.initDateRangePicker(picker, startDate, endDate, 'Personalizado');
    });
  }

  initDateRangePicker(picker, start, end, label) {
    let title = '', range = '';

    if (label == 'Personalizado') {
      range = start.format('DD MMM YYYY') + ' - ' + end.format('DD MMM YYYY');
    } else {
      title = !!label ? label : 'Esse Mês';
      range = start.format('MMMM [de] YYYY');
    }

    picker.html(range);
  }
};